import { olympusService as e } from "../services/olympus/olympus.service.js";
//#region src/lib/utils/getModelAssetMetadata.ts
var t = async (t, n, r) => {
	if (e.olympusCore) return e.olympusCore.getModelAssetMetadata(t, n);
	if (!r) throw Error("No olympusCore or customRenderer available to get model asset metadata");
	let i = URL.createObjectURL(t);
	try {
		return await r.scene.loadMeshMetadata({
			name: "metadata",
			filename: t.name,
			url: i,
			calculateExtents: n?.calculateExtents,
			calculateStatistics: n?.calculateStatistics
		});
	} finally {
		URL.revokeObjectURL(i);
	}
};
//#endregion
export { t as getModelAssetMetadata };
